<dx-popup
    #applyDebitEditorPopup
    minWidth="150px"
    minHeight="100px"
    width="70%"
    height="65%"
    [title]="popUpTitle"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div #applyDebits *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="apply-debit-box-container">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="cc-text-bold">Source Transactions</div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="grid-container">
                        <dx-data-grid
                            height="100%"
                            allowColumnResizing="true"
                            class="grid-bottom-padding"
                            [dataSource]="sourceTransactions?.lineItems"
                            [showBorders]="true"
                            [showColumnLines]="true"
                            [showRowLines]="true"
                            [hoverStateEnabled]="true"
                            [columnAutoWidth]="true"
                        >
                            <dxi-column
                                dataType="string"
                                cellTemplate="amountCellTemplate"
                                headerCellTemplate="headerTemplate"
                            ></dxi-column>

                            <div *dxTemplate="let row of 'amountCellTemplate'">
                                {{ getSourceTransactionLineItemDetail(row) }}
                            </div>
                            <div *dxTemplate="let header of 'headerTemplate'">
                                <div class="cc-text-bold dx-theme-text-color">
                                    AP Adjustment: {{ sourceTransactions?.documentNumber }}, Applicable Amount: {{
                                    sourceTransactions?.amount | ccCurrency }}
                                </div>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="cc-text-bold">Target Transactions</div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="grid-container">
                        <dx-data-grid
                            #targetTransactionDataGrid
                            width="100%"
                            height="100%"
                            keyExpr="id"
                            class="grid-bottom-padding"
                            [highlightChanges]="true"
                            [repaintChangesOnly]="true"
                            [allowColumnReordering]="true"
                            [allowColumnResizing]="true"
                            [showBorders]="true"
                            [showColumnLines]="true"
                            [showRowLines]="true"
                            [dataSource]="targetTransactions"
                            (onSelectionChanged)="onGridSelectionChange()"
                            (onEditingStart)="onEditingStart($event)"
                        >
                            <dxo-selection
                                showCheckBoxesMode="always"
                                mode="multiple"
                                [allowSelectAll]="false"
                            ></dxo-selection>
                            <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                            <dxo-pager [visible]="false"></dxo-pager>
                            <dxo-paging [enabled]="false"></dxo-paging>

                            <dxi-column
                                dataType="number"
                                dataField="appliedAmount"
                                caption="Apply Amount"
                                [format]="currencyFormat"
                                [allowSorting]="false"
                                [allowFiltering]="false"
                            ></dxi-column>

                            <dxi-column
                                dataType="string"
                                dataField="documentType"
                                caption="Document Type"
                                [allowEditing]="false"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="documentNumber"
                                caption="Document Number"
                                [allowEditing]="false"
                            ></dxi-column>
                            <dxi-column
                                dataType="number"
                                dataField="amount"
                                caption="Amount"
                                [format]="currenctFormat"
                                [allowEditing]="false"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="openBalance"
                                caption="Open Balance"
                                [format]="currenctFormat"
                                [allowEditing]="false"
                            ></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="documentDate"
                                caption="Doc Date"
                                [format]="dateFormat"
                                [allowEditing]="false"
                            ></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="postDate"
                                caption="Post Date"
                                [format]="dateFormat"
                                [allowEditing]="false"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                caption="Dim/Option Code"
                                cellTemplate="dimensionOptionCellTemplate"
                                [allowEditing]="false"
                            ></dxi-column>

                            <div *dxTemplate="let d of 'dimensionOptionCellTemplate'">
                                <div *ngFor="let lineItem of d.data.lineItems">
                                    {{ getDimensionTitle(lineItem) }}
                                </div>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-form width="50%" height="100%" [colCount]="1">
                        <dxi-item>
                            <dxo-label text="Total Applied"></dxo-label>
                            <div *dxTemplate>
                                <dx-number-box
                                    [readOnly]="true"
                                    [format]="currencyFormat"
                                    [value]="totalAppliedAmount"
                                ></dx-number-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Remaining Unapplied"></dxo-label>
                            <div *dxTemplate>
                                <dx-number-box
                                    [readOnly]="true"
                                    [format]="currencyFormat"
                                    [value]="remainingUnappliedAmount"
                                ></dx-number-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Post Date"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    type="date"
                                    [min]="applyDebitEditor?.closedBookPeriod"
                                    [max]="applyDebitEditor?.maxApplyDate"
                                    [openOnFieldClick]="true"
                                    [(value)]="applyDebitParameter.applyDate"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-container">
                        <div class="left-content">
                            <dx-button
                                type="default"
                                text="Cancel"
                                hint="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>
                        <div class="right-content">
                            <dx-button
                                type="success"
                                text="Apply"
                                hint="Apply"
                                [disabled]="targetParams.length === 0"
                                [icon]="iconCheck"
                                (onClick)="onApplyClick()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-apply-debit-line-item-amount-editor
    *ngIf="showLineItemAmountEditor"
    [sourceTransactions]="sourceTransactions"
    [targetTransactions]="targetTransactions"
    [targetTransactionId]="selectedTargetTransactionId"
    (onClose)="onLineItemAmountEditorClose()"
    (onSave)="onLineItemAmountEditorSave($event)"
></app-apply-debit-line-item-amount-editor>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#applyDebits' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
